<template>
  <NuxtLink :to="to" class="navbar-search-item" @click="$emit('track')">
    <div class="navbar-search-item-image">
      <div class="image is-4by3">
        <img
          v-if="image?.__typename === 'MediaImage' && image?.fileUrl?.path"
          :src="image.fileUrl.path"
        />
        <img
          v-if="image?.__typename === 'MediaCanto' && image?.assetId"
          :src="
            getCantoImageStyle(image.assetId, { width: 300, height: 200 }).url
          "
        />
      </div>
    </div>
    <div class="navbar-search-item-text">
      <h3 class="title text-size-6 desktop:text-size-4">
        {{ title }}
      </h3>

      <ul
        v-if="category"
        class="navbar-search-item-meta subtitle is-5 has-margin-top-0 text-size-6 fullhd:text-size-5"
      >
        <li class="mb-6 flex items-center">
          <span class="icon is-size-auto mr-1">
            <SpriteSymbol
              :name="icon.icon as any"
              class="size-6 desktop:size-4"
            />
          </span>
          <span class="text-size-6 desktop:text-size-5">{{ icon.label }}</span>
        </li>
      </ul>
      <p class="text-size-6 desktop:text-size-5">{{ text }}</p>
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import type {
  MediaCantoFragment,
  MediaImageFragment,
} from '#graphql-operations'
import { getPathFromUrl } from '~/helpers'
import { getCantoImageStyle } from '~/helpers/canto'

const props = defineProps<{
  id: string
  title: string
  url: string
  nid?: string
  tid?: string
  text: string
  bundle?: string
  image?: MediaImageFragment | MediaCantoFragment
  category?: string
  logoThemeText?: string
  logoThemeColor?: string
  score?: number
  highlight?: string
  categoryDescription?: string
  categoryName?: string
  categoryIconUrl?: string
  categoryLandingPage?: string
}>()

defineEmits<{
  (e: 'track'): void
}>()

const to = computed(() => ({
  path: getPathFromUrl(props.url),
  params: { search: true },
}))

const icon = computed(() => {
  if (props.bundle === 'place') {
    return { icon: 'map', label: 'Place' }
  } else if (props.bundle === 'accomodation') {
    return { icon: 'accomodation', label: 'Accommodation' }
  } else if (props.bundle === 'tour') {
    return { icon: 'tour', label: 'Tour' }
  }
  return { icon: 'info', label: 'Information' }
})
</script>

<style lang="postcss">
.navbar-search-item {
  @apply block border-b border-solid border-border px-0 py-size-4 desktop:flex;

  &:hover {
    @apply desktop:bg-scheme-main-bis;
  }

  .title {
    @apply flex items-center;
    margin-bottom: 0.25rem;
  }

  p {
    @apply font-normal text-scheme-invert;
  }
}
.navbar-search-item-image {
  @screen belowDesktop {
    width: 5rem;
    margin-left: 1rem;
    margin-bottom: 1rem;
    float: right;
  }
  @screen desktop {
    margin-right: 1rem;
    flex: 0 0 10rem;
  }
  @screen widescreen {
    margin-right: 1.75rem;
    flex: 0 0 13rem;
  }
}
.navbar-search-item-text {
  @apply desktop:flex desktop:flex-col;

  > p {
    @apply desktop:text-muted-hover;
    @screen desktop {
      margin-top: auto;
      max-width: 40rem;
    }
  }
}

.navbar-search-item-meta {
  @apply flex;
  li {
    margin-right: 0.75rem;
  }
}
</style>
